import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import { Component } from "react";
import { BsDatabaseGear } from "react-icons/bs";
import MaxContagemInput from "../../ui/MaxContagemInput";
import { httpGet, httpPost } from "../../util/http";

export default class Settings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            changed: false,
            loading: false,
            maxCnt: '',
            cacheLoading: false,
        }

    }

    componentDidMount() {
        this.refresh();
    }

    cacheClean() {
        this.setState({ cacheLoading: true });
        httpGet('/settings/cacheclean',
            settings => {
                this.setState({
                    cacheLoading: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ cacheLoading: false });
            },
        );
    }

    refresh() {
        this.setState({ loading: true });
        httpGet('/settings/read',
            settings => {
                console.log(settings)
                this.setState({
                    maxCnt: settings?.max_cnt,
                    loading: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
        );
    }

    onSubmit(e) {
        e.preventDefault();
        this.setState({
            loading: true,
        });
        httpPost('/settings/save',
            { maxCnt: this.state.maxCnt },
            () => {
                this.setState({
                    changed: false,
                    loading: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
        );
    }

    render() {
        return (
            <form onSubmit={e => this.onSubmit(e)}>
                <Stack>
                    <Stack direction="row" borderBottom={1} borderColor="primary.main">
                        <Typography variant="body2" color="primary"><BsDatabaseGear size={16} /><Box ml={1} component="span"><b>Configurações</b></Box></Typography>
                    </Stack>
                    <Typography mt={1} variant="caption" color="primary">Configurações do sistema</Typography>
                    <Stack padding={2} mt={1} gap={1} borderRadius={2} borderColor="#f0fbff">
                        <Box><MaxContagemInput value={this.state.maxCnt} onChange={maxCnt => this.setState({ maxCnt, changed: true })} /></Box>
                        {this.state.changed && <Box>{this.state.loading ? <CircularProgress color="success" size={20} /> : <Button type="submit" size="small" color="btnStyle" variant="contained" disableElevation>Salvar</Button>}</Box>}
                    </Stack>
                    <Stack padding={2} direction="row">
                        <Typography mt={0.8} mr={1} variant="caption">Limpeza do cache de produtos: </Typography>
                        <Box>{this.state.cacheLoading ? <CircularProgress color="success" size={20} /> : <Button onClick={() => this.cacheClean()} size="small" color="btnStyle" variant="contained" disableElevation>Limpar</Button>}</Box>
                    </Stack>
                </Stack>
            </form>
        );
    }
}
